import { render, staticRenderFns } from "./PoliciesListUserPolicies.vue?vue&type=template&id=71582390&"
import script from "./PoliciesListUserPolicies.vue?vue&type=script&lang=js&"
export * from "./PoliciesListUserPolicies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports